let DateUtil = {
    dateToString(date) {
        let isoDate = date.toISOString();
        return isoDate.replace('T', ' ').substring(0, 19)
    },
    fromUTC(dateString){
        if (!dateString)
            return new Date();
        if(dateString.length < 11)
            dateString+=" 00:00:00-03:00"
        else if (dateString.length < 20)
            dateString += 'Z'

        return new Date(dateString.replace(" ", "T"))
    }
}

export default DateUtil;